import { render, staticRenderFns } from "./NewSection2.vue?vue&type=template&id=573844d3&scoped=true&"
import script from "./NewSection2.vue?vue&type=script&lang=js&"
export * from "./NewSection2.vue?vue&type=script&lang=js&"
import style0 from "./NewSection2.vue?vue&type=style&index=0&id=573844d3&lang=scss&scoped=true&"
import style1 from "./NewSection2.vue?vue&type=style&index=1&id=573844d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573844d3",
  null
  
)

export default component.exports